import { render, staticRenderFns } from "./NewsOptionsModal.vue?vue&type=template&id=89f8897c&"
import script from "./NewsOptionsModal.vue?vue&type=script&lang=js&"
export * from "./NewsOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports